import { useState } from "react";



const ActivationInfo = (props) => {

    const [msg, setMsg] = useState('');

    const resendLink = () => {

        var responseOk = false;
        var responseStatus = 0;
    
        fetch('https://studiotworzenia.pl/resend.php', {
            crossDomain: true,
            method: 'GET',
            headers: {'Cache-Control': 'no-store', 'Auth-Code': 'Bearer '+localStorage.getItem('user_code')},
        })
        .then((response) => {
            responseOk = response.ok;
            responseStatus = response.status;
            return response.json();
        })
        .then((result) => {
            if(responseOk){
                if(result.mailResult)
                    setMsg('Link wysłany. Sprawdź pocztę.');
            }
        });
    }

    return(
    <p className="box has-background-link-dark has-text-white mt-4">Pamiętaj, że tylko potwierdzone konta wpisywane są do rankingu!<br/><a onClick={resendLink}>Wyślij ponownie link aktywacyjny</a><br/>Twój email: {props.email}<br/>
    {msg}</p>
    );
}


export default ActivationInfo;